"use client";

import { useCallback, useEffect, useRef, type RefObject } from "react";
import type { UseCarouselScrollStateParams } from "./carouselScrollStateTypes";
import type { CarouselTeamSelectInput } from "./types";

export function useCarouselCallbackRefs({
  onCenteredTeamChange,
  onTeamSelect,
}: Pick<
  UseCarouselScrollStateParams,
  "onCenteredTeamChange" | "onTeamSelect"
>): {
  handleSelectTeam: (input: CarouselTeamSelectInput) => void;
  onCenteredTeamChangeRef: RefObject<
    UseCarouselScrollStateParams["onCenteredTeamChange"]
  >;
} {
  const onTeamSelectRef = useRef(onTeamSelect);
  const onCenteredTeamChangeRef = useRef(onCenteredTeamChange);

  useEffect(() => {
    onTeamSelectRef.current = onTeamSelect;
  }, [onTeamSelect]);

  useEffect(() => {
    onCenteredTeamChangeRef.current = onCenteredTeamChange;
  }, [onCenteredTeamChange]);

  const handleSelectTeam = useCallback(
    (input: CarouselTeamSelectInput): void => {
      onTeamSelectRef.current?.(input);
    },
    [],
  );

  return {
    handleSelectTeam,
    onCenteredTeamChangeRef,
  };
}
